"use strict";
/**
 * Five approved scenarios (base + four stress cases). All overrides
 * are ADDITIVE deltas applied to the user's baseline inputs.
 *
 * Values below are the v1 leadership-approved shifts:
 *   Lower return       — accumulationReturn −2%, withdrawalReturn −1%
 *   Higher inflation   — preInflation +1%, postInflation +1%
 *   Longer life        — planIncomeUntilAge +5 years
 *   Combined stress    — all of the above
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.runScenarios = exports.applyOverrides = exports.buildScenarioOverrides = exports.SCENARIO_ORDER = void 0;
const index_core_1 = require("./index-core");
const LABEL = {
    base: "Base case",
    lower_return: "Lower return",
    higher_inflation: "Higher inflation",
    longer_life: "Longer life",
    combined_stress: "Combined stress",
};
exports.SCENARIO_ORDER = [
    "base",
    "lower_return",
    "higher_inflation",
    "longer_life",
    "combined_stress",
];
function buildScenarioOverrides(inputs, name) {
    switch (name) {
        case "base":
            return {};
        case "lower_return":
            return {
                accumulationReturn: Math.max(-0.99, inputs.accumulationReturn - 0.02),
                withdrawalReturn: Math.max(-0.99, inputs.withdrawalReturn - 0.01),
            };
        case "higher_inflation":
            return {
                preRetirementInflation: inputs.preRetirementInflation + 0.01,
                postRetirementInflation: inputs.postRetirementInflation + 0.01,
            };
        case "longer_life":
            return {
                planIncomeUntilAge: inputs.planIncomeUntilAge + 5,
            };
        case "combined_stress":
            return {
                accumulationReturn: Math.max(-0.99, inputs.accumulationReturn - 0.02),
                withdrawalReturn: Math.max(-0.99, inputs.withdrawalReturn - 0.01),
                preRetirementInflation: inputs.preRetirementInflation + 0.01,
                postRetirementInflation: inputs.postRetirementInflation + 0.01,
                planIncomeUntilAge: inputs.planIncomeUntilAge + 5,
            };
    }
}
exports.buildScenarioOverrides = buildScenarioOverrides;
function applyOverrides(inputs, o) {
    return {
        ...inputs,
        accumulationReturn: o.accumulationReturn ?? inputs.accumulationReturn,
        withdrawalReturn: o.withdrawalReturn ?? inputs.withdrawalReturn,
        preRetirementInflation: o.preRetirementInflation ?? inputs.preRetirementInflation,
        postRetirementInflation: o.postRetirementInflation ?? inputs.postRetirementInflation,
        planIncomeUntilAge: o.planIncomeUntilAge ?? inputs.planIncomeUntilAge,
    };
}
exports.applyOverrides = applyOverrides;
function runScenarios(baseInputs) {
    return exports.SCENARIO_ORDER.map((name) => {
        const overrides = buildScenarioOverrides(baseInputs, name);
        const inputs = applyOverrides(baseInputs, overrides);
        const core = (0, index_core_1.runCoreCalculation)(inputs);
        return {
            name,
            label: LABEL[name],
            requiredCorpus: core.required.requiredTotalRetirementCorpus,
            projectedCorpus: core.accumulation.projectedRetirementCorpus,
            gap: core.gap.gap,
            requiredStartingMonthlySip: core.gap.requiredStartingMonthlySip,
            accumulationYears: core.gap.accumulationYears,
            alreadyRetired: core.gap.alreadyRetired,
            planIncomeUntilAge: inputs.planIncomeUntilAge,
            accumulationReturn: inputs.accumulationReturn,
            withdrawalReturn: inputs.withdrawalReturn,
            preRetirementInflation: inputs.preRetirementInflation,
            postRetirementInflation: inputs.postRetirementInflation,
        };
    });
}
exports.runScenarios = runScenarios;
